import { getHours } from 'date-fns';
import { toLower } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { getMessage } from '@gef-ui/localization/messages';
import { joinString } from '@gef-ui/utils';

import { EVENT, EVENT_TYPE } from 'features/common/gtm/constants';
import { useDataLayer } from 'features/common/gtm/hooks';

export const useTitle = () => {
	const hours = getHours(new Date());

	if (hours >= 6 && hours < 10) {
		return getMessage('dashboard:title_1');
	} else if (hours >= 10 && hours < 12) {
		return getMessage('dashboard:title_2');
	} else if (hours >= 12 && hours < 14) {
		return getMessage('dashboard:title_3');
	} else if (hours >= 14 && hours < 17) {
		return getMessage('dashboard:title_4');
	} else if (hours >= 17 && hours < 19) {
		return getMessage('dashboard:title_5');
	} else if (hours >= 19 && hours <= 23) {
		return getMessage('dashboard:title_6');
	}

	return getMessage('dashboard:title');
};

export const useButtonClickDataLayer = () => {
	const handleDataLayer = useDataLayer({
		event: EVENT.buttonClick,
		eventType: EVENT_TYPE.clickType,
	});
	return handleDataLayer;
};

export const useDetailButtonClickDataLayer = () => {
	const handleDataLayer = useDataLayer({
		event: EVENT.buttonClick,
		eventType: EVENT_TYPE.clickType,
		buttonText: 'detail',
	});
	return handleDataLayer;
};

// in LeadsOverview/Lead - we are not sending only "další" but we are including the actual name of the lead type (with "další_" prefix)
export const usePlusMoreButtonClickDataLayer = (buttonText) => {
	const finalButtonText = !isNilOrEmpty(buttonText) ? toLower(joinString('', ['další_', buttonText])) : 'další';
	const handleDataLayer = useDataLayer({
		event: EVENT.buttonClick,
		eventType: EVENT_TYPE.clickType,
		buttonText: finalButtonText,
	});
	return handleDataLayer;
};
